<template>
<div class="row justify-content-center mt-0">
    <fieldset style="text-align: left; padding: 30px">
        <vs-tabs class="custom-tabs" alignment="fixed">
            <vs-tab label="Quick Participant Registration">
                <h5 class="mt-4">Participant Registration</h5>
                <div class="row mt-5">
                    <div v-if="isForm">
                        <form @submit.prevent="detailsRegistration">
                            <div class="row ml-0 mr-0">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Participant Name
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" v-model="name" class="form-control form-control-sm" placeholder id="first" autocomplete="off" @input="name = name.replace(/[^a-zA-Z\s]/g, '')" />
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            CNIC
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input v-mask="'(99999) 9999999-9'" type="text" class="form-control form-control-sm" placeholder id="first" v-model="cnic" autocomplete="off" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Username
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" v-model="username" class="form-control form-control-sm" placeholder id="first" autocomplete="off" @keydown.space.prevent />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Contact
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input v-mask="'(9999)-9999999'" type="text" class="form-control form-control-sm" placeholder id="first" v-model="mobilenumber" autocomplete="off" />
                                    </div>
                                </div>
                                <!-- -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Department / Section
                                            <span class="text-danger">*</span>
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="department" :searchable="true">
                                            <option v-for="(item,index) in departmentArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.title}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Designation
                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="designation" :searchable="true">
                                            <option v-for="(item,index) in designationArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.title}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Sector
                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="sector" :searchable="true">
                                            <option v-for="(item,index) in sectorArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.name}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Institution
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" v-model="institute" class="form-control form-control-sm" placeholder id="first" autocomplete="off" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Profession
                                            <span class="text-danger">*</span>
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="profession" :searchable="true">
                                            <option v-for="(item,index) in professionArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.name}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label style="font-weight:700;" for="first">Location <span class="text-danger">*</span></label>
                                    <selectize id="select-state" v-model="district">
                                        <option v-for="(item,index) in districtArr" :key="index" :value="item.id">
                                            {{item.title}}, {{item.province.title}},
                                            {{item.province.country.title}}
                                        </option>
                                    </selectize>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Address
                                        </label>
                                        <input type="text" v-model="address" class="form-control form-control-sm" placeholder id="first" autocomplete="off" />
                                    </div>
                                </div>
                                <!-- -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Passport
                                            <!-- <span class="text-danger">*</span> -->
                                        </label>
                                        <input type="text" class="form-control form-control-sm" placeholder id="first" v-model="passport" autocomplete="off" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Email
                                        </label>
                                        <input type="text" class="form-control form-control-sm" placeholder id="first" v-model="email" autocomplete="off" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Password
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" class="form-control form-control-sm" placeholder="This will be used as password" id="first" v-model="code" autocomplete="off" />
                                    </div>
                                </div>

                                <div class="col-sm-4 mt-3" style="
                                        padding-left: 5px;
                                        display: inline-flex;
                                      ">
                                    <label class="col-sm-4 col-form-label" style="font-weight: 700">
                                        Gender
                                        <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                    </label>
                                    <div class="col-sm-4" style="margin-top: 7px">
                                        <vs-radio v-model="gender" vs-name="radios1" style="font-weight: 700" vs-value="male">Male</vs-radio>
                                    </div>
                                    <div class="col-sm-4" style="margin-top: 7px">
                                        <vs-radio v-model="gender" vs-name="radios1" style="font-weight: 700" vs-value="female">Female</vs-radio>
                                    </div>
                                    <div class="col-sm-6" style="margin-top: 7px">
                                        <vs-radio style="font-weight: 700" v-model="gender" vs-name="radios1" vs-value="rather not say">Other</vs-radio>
                                    </div>
                                </div>
                            </div>
                            <div class="row ml-0 mr-0">
                                <div class="col-md-12">
                                    <b-button type="submit" class="btn btn-primary btn-sm" variant="primary">Register
                                    </b-button>

                                    <!-- Next Step Button Ends  -->
                                </div>
                            </div>
                        </form>
                    </div>
                    <div v-if="isEditForm">
                        <form @submit.prevent="submitEditForm">
                            <div class="row ml-0 mr-0">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Participant Name
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" v-model="name" class="form-control form-control-sm" placeholder id="first" @input="name = name.replace(/[^a-zA-Z\s]/g, '')" />
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            CNIC
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input v-mask="'(99999) 9999999-9'" type="text" class="form-control form-control-sm" placeholder id="first" v-model="cnic" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Username
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" v-model="username" class="form-control form-control-sm" placeholder id="first" autocomplete="off" @keydown.space.prevent />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Contact
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input v-mask="'(9999)-9999999'" type="text" class="form-control form-control-sm" placeholder id="first" v-model="mobilenumber" />
                                    </div>
                                </div>
                                <!-- -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Department / Section
                                            <span class="text-danger">*</span>
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="department" :searchable="true">
                                            <option v-for="(item,index) in departmentArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.title}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Designation
                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="designation" :searchable="true">
                                            <option v-for="(item,index) in designationArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.title}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Institution
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" v-model="institute" class="form-control form-control-sm" placeholder id="first" autocomplete="off" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Sector
                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="sector" :searchable="true">
                                            <option v-for="(item,index) in sectorArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.name}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Profession
                                            <span class="text-danger">*</span>
                                        </label>
                                        <selectize id="select-state" class="text-capitalize" v-model="profession" :searchable="true">
                                            <option v-for="(item,index) in professionArr" :key="index" :value="item.id" class="text-capitalize">
                                                {{item.name}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label style="font-weight:700;" for="first">Location <span class="text-danger">*</span></label>
                                    <selectize id="select-state" v-model="district">
                                        <option v-for="(item,index) in districtArr" :key="index" :value="item.id">
                                            {{item.title}}, {{item.province.title}},
                                            {{item.province.country.title}}
                                        </option>
                                    </selectize>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Address
                                        </label>
                                        <input type="text" v-model="address" class="form-control form-control-sm" placeholder id="first" autocomplete="off" />
                                    </div>
                                </div>
                                <!-- -->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Passport
                                            <!--   <span class="text-danger">*</span> -->
                                        </label>
                                        <input type="text" class="form-control form-control-sm" placeholder id="first" v-model="passport" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Email
                                        </label>
                                        <input type="text" class="form-control form-control-sm" placeholder id="first" v-model="email" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label style="font-weight: 700" for="first">
                                            Password
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input type="text" class="form-control form-control-sm" placeholder="This will be used as password" id="first" v-model="code" />
                                    </div>
                                </div>

                                <div class="col-sm-4 mt-3" style="
                                        padding-left: 5px;
                                        display: inline-flex;
                                      ">
                                    <label class="col-sm-4 col-form-label" style="font-weight: 700">
                                        Gender
                                        <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                    </label>
                                    <div class="col-sm-4" style="margin-top: 7px">
                                        <vs-radio v-model="gender" vs-name="radios1" style="font-weight: 700" vs-value="male">Male</vs-radio>
                                    </div>
                                    <div class="col-sm-4" style="margin-top: 7px">
                                        <vs-radio v-model="gender" vs-name="radios1" style="font-weight: 700" vs-value="female">Female</vs-radio>
                                    </div>
                                    <div class="col-sm-6" style="margin-top: 7px">
                                        <vs-radio style="font-weight: 700" v-model="gender" vs-name="radios1" vs-value="rather not say">Other</vs-radio>
                                    </div>
                                </div>
                            </div>
                            <input type="hidden" v-model="userId" />
                            <div class="form-group">
                                <div class="row ml-0 mr-0">
                                    <div class="col-sm-12">
                                        <!-- add button starts-->
                                        <b-button type="submit" class="btn btn-primary btn-sm m-1" variant="primary">Update</b-button>
                                        <b-button class="btn btn-primary btn-sm m-1" v-if="!isForm" @click="closeEditForm">Cancel</b-button>
                                        <!-- add button ends -->
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="table-responsive mt-4">
                        <div class="col-sm-12">
                            <!-- new form popup starts -->
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="scroll-table-container">
                                            <table class="table table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Sr#</th>
                                                        <th>Participant Name</th>
                                                        <th>CNIC</th>
                                                        <!-- <th>Passport</th> -->
                                                        <th>Contact Number</th>
                                                        <th>Username</th>
                                                        <th>Department</th>
                                                        <th>Designation</th>
                                                        <th>Sector</th>
                                                        <th>District</th>
                                                        <th>Address</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tr v-for="(
                                              item, index
                                            ) in itemsTrainee" v-bind:key="item.id">
                                                    <td>{{ index + 1 }}</td>
                                                    <td class="text-capitalize">
                                                        {{ item.name ? item.name : 'N/A' }}
                                                    </td>
                                                    <td>
                                                        {{ item.cnic ? item.cnic : 'N/A' }}
                                                    </td>

                                                    <!-- <td>
                                                        {{ item.passportNo ? item.passportNo : 'N/A' }}
                                                    </td> -->

                                                    <td>
                                                        {{ item.contactNo ? item.contactNo : 'N/A' }}
                                                    </td>

                                                    <td>
                                                        {{ item.username ? item.username : 'N/A' }}
                                                    </td>

                                                    <td>
                                                        {{ item.traineeDepartment ? item.traineeDepartment : 'N/A' }}
                                                    </td>

                                                    <td>
                                                        {{ item.traineeDesignation ? item.traineeDesignation : 'N/A' }}
                                                    </td>

                                                    <td>
                                                        {{ item.sector ? item.sector : 'N/A' }}
                                                    </td>

                                                    <td>
                                                        {{ item.district ? item.district : 'N/A' }}
                                                    </td>

                                                    <td>
                                                        {{ item.address ? item.address : 'N/A' }}
                                                    </td>

                                                    <td>
                                                        <a @click="editRecord(item.id)">
                                                            <vs-icon class="mr-1" icon="edit" style="
                                                    color: #007bff;
                                                    font-size: 20px;
                                                    font-weight: 600;
                                                    cursor: pointer;
                                                  "></vs-icon>
                                                        </a>
                                                        <a @click="unassignedTraining(item.id)">
                                                            <vs-icon class="mr-1" icon="clear" style="
                                                    color: #ff0000c7;
                                                    font-size: 20px;
                                                    font-weight: 600;
                                                    cursor: pointer;
                                                  "></vs-icon>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- new form popup ends -->
                        </div>
                    </div>
                </div>
            </vs-tab>
            <vs-tab label="Registered Participants" @click="checkTraineeList()">
                <div class="table-responsive mt-4">
                    <div class="col-sm-12">
                        <b-card>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="col-sm-4 float-left mb-2 p-0">
                                            <input type="text" placeholder="Search ..." v-model="searchQuery" class="search_button form-control form-control-sm" @keyup.enter="filterData" @input="callSearch" />
                                            <button class="clear_button" @click="getAllTraining" type="button">
                                                Search
                                            </button>
                                            <i v-if="searchQuery !== ''" class="material-icons close_icon" @click="clearSearch">close</i>
                                        </div>
                                        <div class="col-sm-4 float-right mb-2 p-0">
                                            <Pagination :current-page="currentPage" :record-limit="recordLimit" :total-counts="totalCounts" @prev-page="prevPage" @next-page="nextPage" @go-to-page="goToPage" />
                                            <div class="page-count">
                                                {{((currentPage-1)*50)+registeredTrainerArr.length}}
                                                Records out of
                                                {{this.totalCounts}}
                                            </div>
                                        </div>
                                        <table class="table table-hover">
                                            <tr style="color: #000 !important">
                                                <th>Sr#</th>
                                                <th>Participant Name</th>
                                                <th>CNIC</th>
                                                <th>Email</th>
                                                <th>Department</th>
                                                <th>Designation</th>
                                                <th>Sector</th>
                                                <th>District</th>
                                                <th>Address</th>
                                                <th>Action</th>
                                            </tr>
                                            <tr v-for="(item, index) in registeredTrainerArr" v-bind:key="item.id">
                                                <td>{{ index + 1 + offSet }}</td>
                                                <td class="text-capitalize">
                                                    {{ item.name ? item.name : 'N/A' }}
                                                </td>
                                                <td>
                                                    {{ item.cnic ? item.cnic : 'N/A' }}
                                                </td>
                                                <td>
                                                    {{ item.contactNo ? item.contactNo : 'N/A' }}
                                                </td>

                                                <td>
                                                    {{ item.department ? item.department : 'N/A' }}
                                                </td>

                                                <td>
                                                    {{ item.designation ? item.designation : 'N/A' }}
                                                </td>

                                                <td>
                                                    {{ item.sector ? item.sector : 'N/A' }}
                                                </td>

                                                <td>
                                                    {{ item.district ? item.district : 'N/A' }}
                                                </td>

                                                <td>
                                                    {{ item.address ? item.address : 'N/A' }}
                                                </td>
                                                <td v-if=" item.status == 'found'">
                                                    <span>
                                                        <a @click="
                                                    unassignedTraining(item.id)
                                                  " class="unassign_training">
                                                            <vs-chip color="danger">Deselect</vs-chip>
                                                        </a>
                                                    </span>
                                                </td>
                                                <td v-else>
                                                    <a @click="
                                                  editRecord2(item.id)
                                                " class="assign_training">
                                                        <vs-chip color="success" class="ml-0">Select for Training</vs-chip>
                                                    </a>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </div>
                </div>
            </vs-tab>
        </vs-tabs>
    </fieldset>

    <!-- Modal -->
    <div class="modal2" v-if="isModalOpen">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Participant Information</h4>
                    <button type="button" class="close" @click="closeModal">
                        &times;
                    </button>
                </div>

                <div class="modal-body">
                    <form @submit.prevent="updateAndAssign">
                        <div class="row ml-0 mr-0">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Participant Name
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" v-model="name" class="form-control form-control-sm" placeholder id="first" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        CNIC
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input v-mask="'(99999) 9999999-9'" type="text" class="form-control form-control-sm" placeholder id="first" v-model="cnic" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Username
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" v-model="username" class="form-control form-control-sm" placeholder id="first" autocomplete="off" @keydown.space.prevent />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Contact
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input v-mask="'(9999)-9999999'" type="text" class="form-control form-control-sm" placeholder id="first" v-model="mobilenumber" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Department / Section
                                        <span class="text-danger">*</span>
                                    </label>
                                    <selectize id="select-state" class="text-capitalize" v-model="department" :searchable="true">
                                        <option v-for="(item,index) in departmentArr" :key="index" :value="item.id" class="text-capitalize">
                                            {{item.title}}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Designation
                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </label>
                                    <selectize id="select-state" class="text-capitalize" v-model="designation" :searchable="true">
                                        <option v-for="(item,index) in designationArr" :key="index" :value="item.id" class="text-capitalize">
                                            {{item.title}}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Institution
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" v-model="institute" class="form-control form-control-sm" placeholder id="first" autocomplete="off" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Sector
                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </label>
                                    <selectize id="select-state" class="text-capitalize" v-model="sector" :searchable="true">
                                        <option v-for="(item,index) in sectorArr" :key="index" :value="item.id" class="text-capitalize">
                                            {{item.name}}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Profession
                                        <span class="text-danger">*</span>
                                    </label>
                                    <selectize id="select-state" class="text-capitalize" v-model="profession" :searchable="true">
                                        <option v-for="(item,index) in professionArr" :key="index" :value="item.id" class="text-capitalize">
                                            {{item.name}}
                                        </option>
                                    </selectize>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label style="font-weight:700;" for="first">Location <span class="text-danger">*</span></label>
                                <selectize id="select-state" v-model="district">
                                    <option v-for="(item,index) in districtArr" :key="index" :value="item.id">
                                        {{item.title}}, {{item.province.title}},
                                        {{item.province.country.title}}
                                    </option>
                                </selectize>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Address
                                    </label>
                                    <input type="text" v-model="address" class="form-control form-control-sm" placeholder id="first" autocomplete="off" />
                                </div>
                            </div>
                            <!-- -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Passport
                                    </label>
                                    <input type="text" class="form-control form-control-sm" placeholder id="first" v-model="passport" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first"> Email </label>
                                    <input type="text" class="form-control form-control-sm" placeholder id="first" v-model="email" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label style="font-weight: 700" for="first">
                                        Password
                                        <span class="text-danger">*</span>
                                    </label>
                                    <input type="text" class="form-control form-control-sm" placeholder="This will be used as password" id="first" v-model="code" />
                                </div>
                            </div>

                            <div class="col-sm-4 mt-3" style="
                                        padding-left: 5px;
                                        display: inline-flex;
                                      ">
                                <label class="col-sm-4 col-form-label" style="font-weight: 700">
                                    Gender
                                    <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                </label>
                                <div class="col-sm-4" style="margin-top: 7px">
                                    <vs-radio v-model="gender" vs-name="radios1" style="font-weight: 700" vs-value="male">Male</vs-radio>
                                </div>
                                <div class="col-sm-4" style="margin-top: 7px">
                                    <vs-radio v-model="gender" vs-name="radios1" style="font-weight: 700" vs-value="female">Female</vs-radio>
                                </div>
                                <div class="col-sm-6" style="margin-top: 7px">
                                    <vs-radio style="font-weight: 700" v-model="gender" vs-name="radios1" vs-value="rather not say">Other</vs-radio>
                                </div>
                            </div>
                        </div>
                        <input type="hidden" v-model="userId" />
                        <div class="form-group">
                            <div class="row ml-0 mr-0">
                                <div class="col-sm-12">
                                    <!-- add button starts-->
                                    <b-button type="submit" class="btn btn-primary btn-sm m-1" variant="primary">Update & Select</b-button>
                                    <b-button class="btn btn-primary btn-sm m-1" v-if="!isForm" @click="closeEditForm">Cancel</b-button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Selectize from "vue2-selectize";
import axios from "axios";
import Pagination from '../../../../components/Pagination.vue';

export default {
    data: () => ({
        currentPage: 1,
        recordLimit: 50,
        totalCounts: 0,
        offSet: 0,
        searchQuery: "",
        isSidebar: false,
        whichSelect: 0,
        role: "",
        designation: "",
        profession: "",
        professionArr: [],
        valuesArray: [],
        sectorArr: [],
        sector: "",
        radios1: "",
        gender: "",
        success: "",
        passport: "",
        institute: "",
        district: "",
        email: "",
        error: "",
        isEditForm: "",
        cnic: "",
        username: "",
        inValid: [],
        updateTraining: [],
        isForm: true,
        isFormData: false,
        selected: "",
        tabIndex: 0,
        contact_number: "",
        contact_email: "",
        address: "",
        primaryUserId: "",
        userId: "",
        registeredTrainerArr: [],
        trainingId: "",
        trainingCode: "",
        departmentArr: [],
        department: "",
        designationArr: [],
        mydate: "",
        startDate: "",
        endDate: "",
        code: "",
        name: "",
        mobilenumber: "",
        trainingArr: [],
        districtArr: [],
        degreenameArr: [],
        itemsTrainee: [],
        training_status: "",
        isModalOpen: false,

    }),
    components: {
        Pagination,
        Selectize
    },
    watch: {

        registeredTrainerArr() {
            if (this.registeredTrainerArr.length > 0) {
                this.closeLoading();
            }
        },
        cnic(newVal) {
            // Remove special characters and update the username
            this.username = newVal.replace(/[\s()-]/g, "");
        },

    },
    mounted() {
        axios.defaults.headers["Authorization"] = localStorage.getItem("token");
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode
            )
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.updateTraining = response.data.training;
                this.trainingId = response.data.training.id;
                this.training_status = response.data.training.trainingstatus;
                this.allTrainer();
                this.getAllTraining();

            });
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainers/all/get")
            .then((response) => {
                this.closeLoading();
                this.valuesArray = response.data;
            });

        //select all district
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/districts/get")
            .then((response) => {

                this.closeLoading();
                this.districtArr = response.data;
            });
        //select all degree names
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/degreenames/get")
            .then((response) => {

                this.closeLoading();
                this.degreenameArr = response.data;
            });
        // department
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/departments/get")
            .then((response) => {

                this.closeLoading();
                this.departmentArr = response.data;
            });
        //designation
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainee-designation/get/all")
            .then((response) => {

                this.closeLoading();
                this.designationArr = response.data;
            });
        // Sector
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/sectors/get")
            .then((response) => {
                this.sectorArr = response.data;
            });
        //
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/traineeroles/get")
            .then((response) => {

                this.closeLoading();
                this.role = response.data[0].id;
            });

        // get all professions
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/professions/get")
            .then(response => {

                this.closeLoading();
                this.professionArr = response.data;
            });

        //select all Training Name
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainers/get")
            .then((response) => {

                this.closeLoading();
                this.trainingArr = response.data;
            });

    },

    methods: {
        // onclick show wizard steps

        unassignedTraining(id) {
            this.openLoading();
            axios
                .post(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/officer/un-assigned/trainee", {
                        trainingId: this.trainingId,
                        trainee: id,
                    }
                )
                .then((response) => {

                    this.closeLoading();
                    if (response.data.success) {
                        this.$toasted.global.successMsg(
                            "Training Un Assigned successfully!"
                        );
                        this.getAllTraining();
                        this.allTrainer();
                    }
                });
        },
        assignedTraining(id) {
            this.openLoading();
            axios
                .post(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/officer/assigned/trainee", {
                        trainingId: this.trainingId,
                        trainee: id,
                    }
                )
                .then((response) => {

                    this.closeLoading();
                    if (response.data.success) {
                        this.$toasted.global.successMsg("Assigned Training successfully!");
                        this.getAllTraining();
                        this.allTrainer();
                    }
                });
        },
        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            this.resetForm();
        },
        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH + "/trainee/user/" + id + "/edit"
                )
                .then((response) => {

                    this.closeLoading();
                    if (response) {
                        this.name = response.data.userstrainee.name;
                        this.username = response.data.userstrainee.username;
                        this.code = response.data.userstrainee.code;
                        this.mobilenumber = response.data.userstrainee.contactNo;
                        this.email = response.data.email;
                        this.cnic = response.data.cnic;
                        this.passport = response.data.passportNo;
                        this.gender = response.data.gender;
                        this.userId = id;
                        this.primaryUserId = response.data.user_trainee_id;
                        this.district = response.data.district_id;
                        this.address = response.data.address;
                        this.designation = response.data.designation;
                        this.institute = response.data.institution;
                        this.department = response.data.department_name;
                        this.sector = response.data.sector_id;
                        this.profession = response.data.profession_id;
                        window.scrollTo(0, 0);
                    }
                });
        },
        deleteRecord(id) {
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(process.env.VUE_APP_BASE_PATH + "/trainee/delete", {
                                id: id,
                            })
                            .then((response) => {
                                this.closeLoading();
                                if (response.data.success) {
                                    this.$toasted.global.successMsg(
                                        "Record has been deleted successfully!"
                                    );
                                    this.allTrainer();
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch((error) => {
                                this.$toasted.global.errorMsg(error);
                            });
                    }
                });
        },
        getAllTraining() {
            axios
                .post(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainee/get/all/fortraining/" +
                    this.trainingId, {
                        "searchText": this.searchQuery,
                        "offSet": this.offSet,
                    }
                )
                .then((response) => {

                    this.registeredTrainerArr = response.data.trainees;
                    this.totalCounts = response.data.totalCount;
                    this.recordLimit = response.data.recordLimit;
                    this.offSet = response.data.currentOffSet;
                });
        },
        allTrainer: function allTrainer() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH + "/trainee/show/" + this.trainingId
                )
                .then((response) => {

                    this.closeLoading();

                    this.itemsTrainee = response.data;
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "material",
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true,
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
            });
        },
        showinputvalue: function (event) {
            this.name = event.target.value;
        },
        detailsRegistration(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }
            if (!this.username) {
                this.inValid.push("Username is required.");
            }
            if (!this.gender) {
                this.inValid.push("Gender type is required.");
            }
            if (!this.department) {
                this.inValid.push("Department type is required.");
            }
            if (!this.district) {
                this.inValid.push("Location type is required.");
            }
            if (!this.designation) {
                this.inValid.push("Designation type is required.");
            }
            if (!this.institute) {
                this.inValid.push("Institute type is required.");
            }
            if (!this.profession) {
                this.inValid.push("Profession is required.");
            }
            if (!this.code) {
                this.inValid.push("Password is required.");
            }
            if (!this.sector) {
                this.inValid.push("Sector type is required.");
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14 || !phone_no1.startsWith('(03')) {
                    this.inValid.push("Must be a valid number starting with '03', e.g., 0345-9992229");
                }
            }
            var cnic_var = this.cnic;
            if (cnic_var == '') {
                this.inValid.push("CNIC is required.")
            } else {
                if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                    cnic_var = cnic_var.replace(/_/g, "");
                    if (cnic_var.length < 17) {
                        this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                    }
                }
            }

            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {

                let self = this;
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/register/trainee", {

                        name: this.name,
                        username: this.username,
                        code: this.code,
                        department_name: this.department,
                        role: this.role,
                        gender: this.gender,
                        contactNo: this.mobilenumber,
                        email: this.email,
                        sessionBy: this.trainingId,
                        statusApproval: 2,
                        //insert trainee information
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        passport: this.passport,
                        district: this.district,
                        address: this.address,
                        designation: this.designation,
                        institute: this.institute,
                        type: "Details Registration",
                        sector_id: this.sector,
                        profession_id: this.profession,
                    })
                    .then((response) => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been saved successfully!");
                            self.resetForm();
                            self.allTrainer();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch((error) => {
                        this.closeLoading();
                        if (error.response && error.response.status === 400) {
                            this.toastError("User already exists with this username, or CNIC ");
                        } else {
                            this.toastError(error.message || "An error occurred");
                        }
                    });
            }
        },
        //Quick training
        quickRegistration(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }
            if (!this.username) {
                this.inValid.push("Username is required.");
            }

            if (!this.gender) {
                this.inValid.push("Gender is required.");
            }
            if (this.email != '') {
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                    this.inValid.push("Invalid email format.");
                }
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined) {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14) {
                    this.inValid.push("Must be valid Number, 0345-9992229");
                }
            }
            var cnic_var = this.cnic;
            if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                cnic_var = cnic_var.replace(/_/g, "");
                if (cnic_var.length < 17) {
                    this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                }
            } else if (
                this.passport == undefined ||
                this.passport == null ||
                this.passport == ""
            ) {
                this.inValid.push("Please Enter Passport Number");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {

                let self = this;
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/register/trainee", {

                        name: this.name,
                        username: this.username,
                        code: this.code,
                        role: this.role,
                        contactNo: this.mobilenumber,
                        email: this.email,
                        gender: this.gender,
                        sessionBy: this.trainingId,

                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        statusApproval: 2,
                        passport: this.passport,
                        type: "Quick Registration",
                    })
                    .then((response) => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been added successfully!");
                            self.resetForm();
                            self.allTrainer();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch((error) => {
                        self.toastError(error);
                    });
            }
        },
        submitEditForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }
            if (!this.username) {
                this.inValid.push("Username is required.");
            }
            if (!this.gender) {
                this.inValid.push("Gender type is required.");
            }

            if (!this.district) {
                this.inValid.push("Location type is required.");
            }
            if (!this.designation) {
                this.inValid.push("Designation type is required.");
            }
            if (!this.department) {
                this.inValid.push("Department type is required.");
            }
            if (!this.institute) {
                this.inValid.push("Institute type is required.");
            }
            if (!this.profession) {
                this.inValid.push("Profession is required.");
            }
            if (!this.code) {
                this.inValid.push("Password is required.");
            }
            if (!this.sector) {
                this.inValid.push("Sector type is required.");
            }
            if (this.email != '') {
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                    this.inValid.push("Invalid email format.");
                }
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14 || !phone_no1.startsWith('(03')) {
                    this.inValid.push("Must be a valid number starting with '03', e.g., 0345-9992229");
                }
            }
            var cnic_var = this.cnic;
            if (cnic_var == '') {
                this.inValid.push("CNIC is required.")
            } else {
                if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                    cnic_var = cnic_var.replace(/_/g, "");
                    if (cnic_var.length < 17) {
                        this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                    }
                }
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {

                let self = this;
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/trainee/update", {

                        name: this.name,
                        username: this.username,
                        code: this.code,
                        role: this.role,
                        contactNo: this.mobilenumber,
                        email: this.email,

                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        gender: this.gender,
                        passport: this.passport,
                        type: "Detail Registration",
                        id: this.userId,
                        primaryUserId: this.primaryUserId,
                        district: this.district,
                        address: this.address,
                        designation: this.designation,
                        institute: this.institute,
                        department_name: this.department,
                        sector_id: this.sector,
                        profession_id: this.profession,
                        sessionBy: this.trainingId,
                    })

                    .then((response) => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.allTrainer();
                            this.isForm = true;
                            this.isEditForm = false;
                            this.closeModal()
                        } else if (response.data.error) {
                            self.toastError(response.data.error);
                        }
                    })
                    .catch((error) => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.name = "";
            this.username = "";
            this.cnic = "";
            this.code = "";
            this.passport = "";
            this.gender = "";
            this.mobilenumber = "";
            this.email = "";
            this.country = "";
            this.province = "";
            this.district = "";
            this.address = "";
            this.department = "";
            this.designation = "";
            this.institute = "";
            this.sector = "";
            this.profession = "";
        },
        successUpload() {
            this.$vs.notify({
                color: "primary",
                title: "Upload Success",
                text: "Your file is uploaded Successfully.",
            });
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        checkTraineeList() {
            if (this.registeredTrainerArr.length == 0) {
                this.openLoading()
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.offSet = this.currentPage * 50 - 50
                this.getAllTraining();
            }
        },
        nextPage() {
            if (this.currentPage * this.recordLimit < this.totalCounts) {
                this.currentPage++;
                this.offSet = this.currentPage * 50 - 50
                this.getAllTraining();
            }
        },
        goToPage(page) {
            this.currentPage = page;
            this.offSet = this.currentPage * 50 - 50
            this.getAllTraining();
        },
        filterData() {
            this.currentPage = 1
            this.offSet = 0
            this.getAllTraining();
        },
        clearSearch() {
            this.currentPage = 1
            this.offSet = 0
            this.searchQuery = ""
            this.getAllTraining();
        },
        callSearch() {
            if (this.searchQuery.length == 0) {
                this.currentPage = 1
                this.offSet = 0
                this.getAllTraining();
            }
        },
        editRecord2(id) {
            this.isModalOpen = true
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH + "/trainee/user/" + id + "/edit"
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) {
                        this.name = response.data.userstrainee.name;
                        this.username = response.data.userstrainee.username;
                        this.code = response.data.userstrainee.code;
                        this.mobilenumber = response.data.userstrainee.contactNo;
                        this.email = response.data.email;
                        this.cnic = response.data.cnic;
                        this.passport = response.data.passportNo;
                        this.gender = response.data.gender;
                        this.userId = id;
                        this.primaryUserId = response.data.user_trainee_id;
                        this.district = response.data.district_id;
                        this.address = response.data.address;
                        this.designation = response.data.designation;
                        this.institute = response.data.institution;
                        this.department = response.data.department_name;
                        this.sector = response.data.sector_id;
                        this.profession = response.data.profession_id;

                    }
                });
        },
        closeModal() {
            this.isModalOpen = false;
            this.resetForm()
        },
        async updateAndAssign(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }
            if (!this.username) {
                this.inValid.push("Username is required.");
            }
            if (!this.gender) {
                this.inValid.push("Gender type is required.");
            }
            if (!this.department) {
                this.inValid.push("Department type is required.");
            }
            if (!this.district) {
                this.inValid.push("District type is required.");
            }
            if (!this.designation) {
                this.inValid.push("Designation type is required.");
            }
            if (!this.institute) {
                this.inValid.push("Institute type is required.");
            }
            if (!this.profession) {
                this.inValid.push("Profession is required.");
            }
            if (!this.code) {
                this.inValid.push("Password is required.");
            }
            if (!this.sector) {
                this.inValid.push("Sector type is required.");
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14 || !phone_no1.startsWith('(03')) {
                    this.inValid.push("Must be a valid number starting with '03', e.g., 0345-9992229");
                }
            }
            var cnic_var = this.cnic;
            if (cnic_var == '') {
                this.inValid.push("CNIC is required.")
            } else {
                if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                    cnic_var = cnic_var.replace(/_/g, "");
                    if (cnic_var.length < 17) {
                        this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                    }
                }
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {

                let self = this;
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/trainee/update", {
                        //insert User informatiion in user table
                        name: this.name,
                        username: this.username,
                        code: this.code,
                        role: this.role,
                        contactNo: this.mobilenumber,
                        email: this.email,
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        gender: this.gender,
                        passport: this.passport,
                        type: "Detail Registration",
                        id: this.userId,
                        primaryUserId: this.primaryUserId,
                        district: this.district,
                        address: this.address,
                        designation: this.designation,
                        institute: this.institute,
                        department_name: this.department,
                        sector_id: this.sector,
                        profession_id: this.profession,
                        sessionBy: this.trainingId,
                    })

                    .then((response) => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.allTrainer();
                            this.closeModal()
                            this.assignedTraining(this.userId);
                        } else if (response.data.error) {
                            self.toastError(response.data.error);
                        }
                    })
                    .catch((error) => {
                        self.toastError(error);
                    });
            }

        },

    },

};
</script>

<style scoped>
#msform fieldset {
    padding: 10px;
    background: #f4f4f4;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

.radio-group {
    position: relative;
    margin-bottom: 25px;
}

.radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
}

.radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
    width: 100%;
    object-fit: cover;
}

.card-body {
    background-color: #f4f4f4 !important;
}

.vuesax-app-is-ltr .con-vs-chip {
    padding: 5px !important;
    border-radius: 5px !important;
    /* padding-right: 10px; */
    cursor: pointer;
}
</style><style>
span.text-chip.vs-chip--text {
    margin-left: 0px !important;
}

.con-vs-chip.vs-chip-danger.con-color,
.con-vs-chip.vs-chip-success.con-color,
.con-vs-chip.vs-chip-warning.con-color {
    padding: 5px !important;
}

.vuesax-app-is-ltr .con-vs-chip {
    float: none !important;
}

.search_button {
    position: relative
}

.clear_button {
    position: absolute;
    right: 0px !important;
    height: 31px !important;
    top: 0px;
    width: 80px;
    border-radius: 5px;
    background-color: #06a6e0;
    border: 1px solid #06a6e0;
    color: #ffffff;
    font-size: 15px;
}

.close_icon {
    position: absolute;
    right: 85px !important;
    top: 4px !important;
    color: #dc3545;
    font-weight: bold;
    cursor: pointer;
    font-size: 24px !important;
}

.page-count {
    text-align: end;
    font-size: 15px;
    color: #06a6e0;
}

.modal2 {

    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

/* Modal content */
.modal-content {
    background-color: #fefefe;
    margin: 1% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 100%;
}

.modal-dialog {
    max-width: 920px
}

.modal-body {
    text-align: justify;
}

/* Close button */
.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.scroll-table-container {
    max-height: 300px;
    overflow-y: scroll;
    position: relative;
}

.scroll-table-container thead th {
    position: sticky;
    top: 0;
    background: white;
    z-index: 2;
}
</style>
